import LessonNeighborsNav from '@/components/lesson/LessonNeighborsNav';
import { useStudentDashboard } from '@/data/context/StudentDashboardContext';
import useLessonNeighbors from '@/data/hook/lesson-progress/useLessonNeighbors';

type LessonNeighborsNavContainerProps = {
  lessonId: number;
  courseSlug?: string;
  klassId?: string;
  className?: string;
};

export default function LessonNeighborsNavContainer({
  lessonId,
  courseSlug,
  klassId,
  className,
}: LessonNeighborsNavContainerProps) {
  const { activeCourseProgress } = useStudentDashboard();
  const neighbors = useLessonNeighbors({
    courseProgressId: activeCourseProgress?.id,
    lessonId,
    slug: courseSlug,
    klassId,
  });

  return <LessonNeighborsNav {...neighbors} className={className} />;
}
